import { AppBar, Toolbar, Container, Typography } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu'
import { useMediaQuery } from '@mui/material'

import { useAuth } from '../../context/SecurityContextProvider'
import NavDropDownBtn from './NavDropDownBtn'
import LoginSignUpButtons from './LoginSignUpButtons'

const styles = {
    appbar: (isMobile) => ({
        backgroundColor: 'primary.main',
        color: 'primary.bg',
        borderRadius: '50px',
        width: isMobile ? '94%' : '62%',
        margin: isMobile ? "1.2rem auto" : '1rem auto',
        p: .8,
        boxShadow: "0 4px 6px -1px #333",
    }),
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        fontFamily: 'Catamaran',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
        textDecoration: 'none',
        fontSize: '2.2rem',
        fontWeight: 900,
        fontFamily: 'inherit',
        lineHeight: '1',
        gap: 1
    },
    navLinkContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: 'center',
    },
    navLink: {
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
        textDecoration: 'none',
        fontSize: '1rem',
        fontWeight: 500,
        fontFamily: 'inherit',
        lineHeight: '1',
        margin: '0 1rem',
    }
}

const NavLinks = () => (
    <div style={styles.navLinkContainer}>
        <Typography variant="h5" noWrap component="a" href="#how-it-works" sx={styles.navLink}>
            How It Works
        </Typography>
        <Typography variant="h5" noWrap component="a" href="#pricing" sx={styles.navLink}>
            Pricing
        </Typography>
        <Typography variant="h5" noWrap component="a" href="#faq" sx={styles.navLink}>
            FAQ
        </Typography>
    </div>
)

function Navbar() {
    const { isAuthenticated, userData } = useAuth()
    const isMobile = useMediaQuery('(max-width:950px)')

    return (
        <AppBar position="static" sx={styles.appbar(isMobile)}>
            <Container>
                <Toolbar sx={styles.toolbar}>
                    <Typography variant="h5" noWrap component="a" href="/" sx={styles.header}>
                        Vibio
                    </Typography>

                    {isMobile ? (
                        isAuthenticated ? (
                            <NavDropDownBtn username={<MenuIcon />} />
                        ) : (
                            <LoginSignUpButtons isMobile />
                        )
                    ) : (
                        <>
                            <NavLinks />
                            {isAuthenticated ? (
                                <NavDropDownBtn username={userData?.username} />
                            ) : (
                                <LoginSignUpButtons isMobile={false} />
                            )}
                        </>
                    )}
                </Toolbar>
            </Container>
        </AppBar>
    )
}

export default Navbar
